import { oc } from '@orpc/contract';
import { policyVersionSchema, publishPolicyInputSchema } from '../schemas/policies.schemas.js';
/**
 * Publishes the draft and archives the version it replaces, in one transaction behind an advisory lock
 * (plan §2.3). Published versions are immutable: saved snapshots keep the version they were computed
 * with (PP AC14).
 */
export const publishPolicyContract = oc
    .route({
    method: 'POST',
    path: '/policies/versions/{versionId}/publish',
    tags: ['Policies'],
    summary: 'Publish the policy draft',
})
    .input(publishPolicyInputSchema)
    .output(policyVersionSchema);
//# sourceMappingURL=publish-policy.contract.js.map